export default {
  about: (state) => state.about,
  personalPhotos: (state) => state.personalPhotos,
  allPhotosLoaded: (state) => state.allPhotosLoaded,
  noResult: (state) => state.noResult,
};
